import { BarceloComponent } from "components-utils";

const FaqComponents = {
  faq: BarceloComponent({ selector: ".cmp-bhg-faq", path: "barcelo/faq/faq/js/c-faq" }),
  widgetFaq: BarceloComponent({ selector: ".cmp-widget-faq", path: "barcelo/faq/widget-faq/js/widget-faq" }),
  dynamicFaqs: BarceloComponent({
    selector: ".c-dynamic-faqs",
    path: "barcelo/faq/dynamic-faqs/js/c-dynamic-faqs",
  }),
};

export default FaqComponents;
